import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{
      fontFamily: '"Nunito Sans", sans-serif',
      lineHeight: 1.6,
      color: '#333',
      backgroundColor: '#fff',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '50px 20px'
      }}>
        <div style={{
          margin: '50px 100px',
          marginBottom: 50
        }}>
          <h1 style={{
            textAlign: 'center',
            marginBottom: 30,
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#2c3e50'
          }}>私隱政策</h1>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            <strong>自2025年8月1日起有效</strong>
          </p>
          
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: 600,
            marginTop: 30,
            marginBottom: 15,
            color: '#34495e'
          }}>靜觀之道計劃</h2>
          <h3 style={{
            fontSize: '1.2rem',
            fontWeight: 600,
            marginTop: 25,
            marginBottom: 10,
            color: '#2c3e50'
          }}>數據私隱及安全政策</h3>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            本政策載列靜觀之道計劃及其附屬機構(統稱「Mindful Gateway」或「我們」)的下列規定：
          </p>
          <ol style={{ marginLeft: 40, marginBottom: 15 }}>
            <li style={{ marginBottom: 8 }}>當閣下下載並使用我們的移動應用程序或以其他方式與我們互動時，我們會訪問、收集哪些有關閣下的資料；</li>
            <li style={{ marginBottom: 8 }}>我們如何使用、分享、存儲、處理和保護這些資料；及</li>
            <li style={{ marginBottom: 8 }}>閣下可以如何訪問和控制這些資料。</li>
          </ol>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            我們承諾遵守香港法例第486章《個人資料（私隱)條例》及香港中文大學對保障個人資料（私隱)的政策，確保閣下的個人資料準確、妥善保存並僅用於統計和服務推廣目的。
          </p>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            在本政策中：「個人資料」指閣下提供的個人資料和詳情，以及我們不時收集、生成和編制的有關閣下的所有資料；「平台」是指我們的應用程式以及我們不時用來推廣和開展計割的其他媒介；「產品[或服務]」是指由Mindful Gateway提供的，與研究、評測、評估、靜觀教育相關的線上和線下的內容、課程、產品或服務。「計劃」與我們的服務條款中的定義相同。
          </p>
          
          <div style={{
            backgroundColor: '#fff3cd',
            padding: 15,
            borderRadius: 5,
            borderLeft: '4px solid #ffc107',
            margin: '15px 0'
          }}>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              <strong>有問題或者擔憂嗎？</strong>
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閱讀本私隱聲明將有助於您了解您的私隱權利和選擇。我們負責決定如何處理您的個人信息。如果您不同意我們的政策和做法，請不要使用我們的服務。如果您仍有任何疑問或疑慮，請通過cumindfulgateway@gmail.com與我們聯繫。
            </p>
          </div>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            在使用本應用程序之前，請仔細閱讀本私隱政策。
          </p>
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            這些私隱政策適用於本應用程序[靜觀之道 Mindful Gateway]。
          </p>
          
          <div style={{ marginBottom: 30 }}>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>點擊以下連結即可查看更多詳情：</p>
            <ol style={{ marginLeft: 40, marginBottom: 20 }}>
              <li style={{ marginBottom: 5 }}><a href="#section1" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們收集哪些關於閣下的資料</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section2" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>收集和使用目的</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section3" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>個人數據的披露和轉移</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section4" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>個人資料的準確性</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section5" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>個人資料的保留</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section6" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>個人資料安全</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section7" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>直銷</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section8" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>閣下的權利</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section9" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>本政策的變更</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section10" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>兒童政策</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section11" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>語言</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section12" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>聯絡我們</a></li>
            </ol>
          </div>

          <div style={{ marginBottom: 30 }} id="section1">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>1. 我們收集哪些關於閣下的資料</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>我們收集閣下以下類型的資料：</p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>閣下在我們的平台上註冊帳戶或註冊我們的產品或服務時提供的帳戶和個人資料，例如閣下的帳號名、電子郵件地址、聯絡電話（統稱「帳戶數據」)；</li>
              <li style={{ marginBottom: 8 }}>閣下通過我們的支援渠道提供的資料，例如當閣下向我們報告問題或與我們的支援團隊互動時，包括任何聯絡資料、文件或屏幕截圖（統稱「支援數據」)；</li>
              <li style={{ marginBottom: 8 }}>閣下通過使用我們的產品或服務提供的內容，例如閣下在我們的應用程式中創建的文件中包含的資料（統稱「用戶内容」)；</li>
              <li style={{ marginBottom: 8 }}>閣下在設定帳戶或個人資料時，或者在參與我們發送給閣下的調查或問卷時設定的通信、營銷和其他偏好(統稱「偏好數據」)；</li>
              <li style={{ marginBottom: 8 }}>有關閣下的設備或互聯網連接的資料，例如閣下的互聯網協議(IP)地址、瀏覽器資訊以及我們根據我們的Cookie政策通過Cookie和其他數據收集技術收集的資料（統稱「技術數據」)；和</li>
              <li style={{ marginBottom: 8 }}>有關閣下使用或訪問我們平台的資料,例如閣下進入、通過和離開我們平臺的點擊流、閣下查看、使用或搜尋產品、下載或其他錯誤、頁面回應時間、停留某些頁面的時間，頁面互動資料（例如滾動、點擊和鼠標懸停)或離開頁面的方法（統稱「使用數據」)。</li>
            </ul>
          </div>

          <div style={{ marginBottom: 30 }} id="section2">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>2. 收集和使用目的</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>我們僅在相關法律及法規允許的情況下使用閣下的個人資料。我們僅在以下情况下使用閣下的個人資料：</p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>我們需要履行我們與閣下的合約，包括營運我們的產品或服務、提供客戶支援和個性化功能，以及保障我們平台的安全；</li>
              <li style={{ marginBottom: 8 }}>我們將其用於研發以改進我們的產品或服務，以及保護我們的合法權益；</li>
              <li style={{ marginBottom: 8 }}>我們需要遵守法律或監管義務。</li>
            </ul>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下已同意我們將閣下的個人資料用於特定目的，閣下有權隨時聯繫我們撤回閣下的同意（聯繫方式請參閱第12段），但請注意，這不會對已經發生的閣下資料的使用產生任何影響。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section3">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>3. 個人數據的披露和轉移</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              為達成上文第2段所述的目的,我們可能會向位於香港境內或境外的第三方轉移、披露、授予訪問權或共享閣下的個人資料'且閣下的個人資料可能會在香港境内或境外轉移，但須遵守以下規定：
            </p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>我們將在法律要求時披露個人資料，例如，應法院命令或執法機構或監管機構的要求；</li>
              <li style={{ marginBottom: 8 }}>我們可能會出於上述目的在必要時與第三方，例如員工、關聯公司（包括我們集團的成員)、合資夥伴、代理、獨立承包商、業務合作夥伴和服務供應商（例如雲端服務供應商)共享閣下的個人資料。除遵守香港個人資料私隱專員公署不時頒布的指引外，在個人資料被提供予第三方組織時,則只會轉移給尊重私隱丶能充分證明其具有管理個人數據的使用和處理的技術能力和組織措施、在數據保護方面有良好記錄、受我們的定期審計並對靜觀之道Mindful Gateway相關成員負有保密義務的第三方組織；</li>
              <li style={{ marginBottom: 8 }}>未經閣下的同意，我們不會使用OpenAPI共享閣下的個人資料；</li>
              <li style={{ marginBottom: 8 }}>若閣下使用與我們的產品或服務相關的任何第三方軟件，例如接合我們平台的任何第三方軟件,閣下可能會授予第三方軟件供應商訪問閣下的帳戶和資料的權限。第三方軟件供應商的政策和程序不受我們控制，本政策不涵蓋第三方軟件供應商如何收集或使用閣下的資料。我們鼓勵閣下在使用第三方軟件之前查閱第三方軟件供應商的私隱政策；</li>
              <li style={{ marginBottom: 8 }}>我們的平台可能包含我們無法控制的第三方網站的連結。若閣下點擊任何這些網站的連結或向他們提交資料，閣下的資料將受其政策約束。我們鼓勵閣下在向第三方網站提交資料之前查閱其私隱政策。</li>
            </ul>
          </div>

          <div style={{ marginBottom: 30 }} id="section4">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>4. 個人資料的準確性</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們制定了若干程序確保用戶個人資料的準確性、完整性和個人資料的使用目的的相關性保持在合理水平。我們的目標是保持閣下的數據是準確且最新的。為此,我們需要閣下向我們披露所有重要資料，並將此類資料中的任何錯誤或變更告知我們。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              當事人可酌情修改其個人資料，詳見下文「閣下的權利」部分。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section5">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>5. 個人資料的保留</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們的政策是保留個人資料的時間不超過達至數據使用目的（或任何直接相關目的)所需時間，但須遵守強制保留數據的法律、法規和監管要求。在此之後，我們將删除或匿名化閣下的個人資料，或者若無法做到這一點，我們將安全地存儲閣下的個人資料並將其隔離以防止進一步使用。我們會根據現行法律及法規定期審查我們數據保留政策的依據和適當性。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section6">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>6. 個人資料安全</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們已制定適當的物理、電子和管理程序，以保障和協助保護用戶個人資料免遭未經授權或意外的訪問、處理、刪除或其他使用。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>我們已採取以下措施來保護閣下的個人資料的安全性和完整性：</p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>閣下在我們的應用程式中創建、存储和電子簽署的任何文件都以加密形式存儲在硬碟上，並通過TLS/SSL加密安全傳輸；</li>
              <li style={{ marginBottom: 8 }}>任何支付交易均使用TLS/SSL技術進行加密；</li>
              <li style={{ marginBottom: 8 }}>能取得閣下的個人資料的訪問僅限於絕對有需要知道的人員或服務供應商，他們只會根據我們的指示處理閣下的個人資料，並承擔保密義務；和</li>
              <li style={{ marginBottom: 8 }}>我們會定期審查我們在資料收集、存儲和處理手法方面的安全措施。</li>
            </ul>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們已制定程序來處理任何涉嫌侵犯私隱的行為，並將在法律要求的情況下通知閣下和任何適用的監管機構。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              雖然我們實施了旨在保護閣下的個人資料的保護措施，但請注意，互聯網上的任何資料傳輸都不是絕對安全的。我們無法保證閣下的個人資料在通過互聯網傳輸期間或存儲在我們的系統上或由我們處理時，是絕對安全和可靠的。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section7">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>7. 直銷</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若我們打算將閣下提供的個人資料（包括閣下的姓名和聯繫方式)用於直銷（例如，向閣下發送與靜觀之道Mindful Gateway及本集團有關的研究活動、新聞、優惠或促銷的營銷通訊)我們將事先取得閣下的同意（或示意不反對)。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若我們打算將閣下提供的個人資料（包括閣下的姓名和聯繫方式)提供給第三方用於直銷，我們將事先取得閣下的同意（或示意不反對)。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下可以使用我們通訊中的取消訂閱連結或聯繫我們以選擇不接收我們的營銷材料(請參閱第12段的聯繫資料)。但請注意'即使閣下選擇不接收我們的管銷材料，閣下仍將繼續收到我們發送的使用我們的產品或服務所必需的通知或資料。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section8">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>8. 閣下的權利</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>閣下有權：</p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>了解我們如何處理閣下的個人資料；</li>
              <li style={{ marginBottom: 8 }}>索取一份我們持有的，關於閣下個人資料的副本；</li>
              <li style={{ marginBottom: 8 }}>要求我們更正關於閣下的個人資料中的任何不準確或錯誤；</li>
              <li style={{ marginBottom: 8 }}>要求删除閣下的個人資料（但請注意，若個人資料對於我們最初收集的目的、記錄保存或法律合規目的仍然是必要的'我們可能無法滿足閣下的刚除要求)；</li>
              <li style={{ marginBottom: 8 }}>反對或限制我們處理閣下的個人資料（包括用於營銷目的）；</li>
              <li style={{ marginBottom: 8 }}>要求以有條理、常用和機器可讀的格式接收閣下的一些個人資料，並要求我們將此類資料傳送給另一方；和</li>
              <li style={{ marginBottom: 8 }}>在我們憑藉閣下同意來處理閣下的個人資料期間，隨時撤回閣下的同意（儘管這不會影響閣下撤回同意之前進行的任何處理的合法性)</li>
            </ul>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們的平台讓閣下能夠更新閣下自己的部分資料，例如閣下可以通過在我們的應用程式中更新閣下的帳戶設定來更改閣下的個人資料。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              作爲安全措施，我們可能需要閣下提供特定資料，以幫助我們處理閣下的私隱要求，或在閣下行使權利時確認閣下身份。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              根據本段提出的任何要求通常會得到免費處理。但若閣下的要求明顯沒有根據、重複或過多，我們可能會收取合理的行政費用。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們將在四十(40)天内回覆所有合理要求。若閣下的要求特别複雜或者閣下提出了數個要求，我們可能需要超過40天的時間。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section9">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>9. 本政策的變更</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              本政策可能會不時修钉。閣下可以在軟件上查閱並獲取本政策的副本（不時修訂）。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section10">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>10. 兒童政策</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              12至18歲人士，需征得其父母或監護人明確同意，方可使用本產品和服務。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們的產品和服務不為12歲以下人士而設。我們不會故意收集12歲以下人士的個人資料。特别在中華人民共和國，未經父母或監護人事先同意，我們不會故意收集或更新12歲以下人士的個人資料。若我們知道12歲以下人士向我們提供了個人資料，我們將採取措施删除此類資料。若閣下認為我們錯誤地或無意地收集了12歲以下人士的資料，請聯繫我們。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section11">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>11. 語言</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              本政策以中文撰寫，並可能會被翻譯為英文。若本政策的中文版本與翻譯版本之間存在任何差異，應以中文版本為準。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section12">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>12. 聯絡我們</h2>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: 20,
              borderRadius: 8,
              margin: '20px 0',
              borderLeft: '4px solid #007bff'
            }}>
              <p style={{ marginBottom: 15, textAlign: 'justify' }}>
                <strong>請通過以下方式與我們聯絡：</strong>
              </p>
              <p style={{ marginBottom: 15, textAlign: 'justify' }}>
                電郵：cumindfulgateway@gmail.com
              </p>
              <p style={{ marginBottom: 15, textAlign: 'justify' }}>
                或提交任何書面請求至：
              </p>
              <p style={{ marginBottom: 15, textAlign: 'justify' }}>
                静观之道計劃<br />
                新界沙田香港中文大學敬霆靜觀研究與培訓中心<br />
                收件人：劉然然
              </p>
            </div>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下有任何問題或疑慮，請第一時間與我們聯絡。若閣下有未解決的問題，閣下有權向閣下居住或工作的國家/地區或閣下認為自己的權利受到侵犯的國家/地區的數據保護機構提出投訴。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
